import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute} from '@angular/router';
/*App imports*/
import { HelpersService } from '../../../services/tools/helpers.service';
import { CreditosService } from "../../../services/creditos.service";
import { NominasService } from "../../../services/creditos/nominas.service";
import { TablaPagosComponent } from '../../components/tabla-pagos/tabla-pagos.component';

@Component({
    selector: 'nomina-detalles',
    templateUrl: './nomina-detalles.component.html',
    styleUrls: ['./nomina-detalles.component.scss']
  })

export class NominaDetallesComponent implements OnInit {
  @ViewChild('tablaPagos') tablaPagos: TablaPagosComponent;
  public  errors:any = {};
  //Helpers
  private sub: any;
  public id: number = null;
  //UI vars
  public credito : any = { cliente : {}, prestamo : {}, sucursal : {} };
  public sectionStatus : any = {};
  public isEditable : boolean = false;
  public isInitialized : boolean = false;

  constructor(
    private route: ActivatedRoute,
    private creditosService: CreditosService,
    private helperService: HelpersService,
    private nominasService: NominasService
    ){
   }

    ngOnInit() {
    this.sub = this.route.params.subscribe(params => {
        this.id = +params['id'];// (+) converts string 'id' to a number
        this.getCredito(this.id);
        this.checkSectionsStatus();
        //Después de que cargan todos los elementos marco el componente como inicializado. 
        //Esto arregla un issue que había, ya que obligaba a que algunos comententes hcieran requests de créditos que se visualizaron anteriormente.
        this.isInitialized = true;
        });
    }
    
    private getCredito(idCreditos : number){
        //TODO: Manejar cuando el id no retorna un crédito valido
        this.nominasService.get(idCreditos).subscribe(
            (response)=>
            {
            const result = response.json().content;
            const credito = result.credito;
            this.credito = credito;

            //Los créditos en estatus pendiente deben mostrarse en modo Editable
            if(credito.statusCredito === 1){
                this.isEditable = true;
            }
            
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.setBackendErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public checkSectionsStatus(){
        //Avisar a los demás componentes que hubo algún cambio en la información del crédito
        if(this.isInitialized){
            this.creditosService.reloadCreditoStatus();
        }
        
        this.creditosService.validateSections(this.id).subscribe(
            (response)=>
            {
            this.sectionStatus = response.json().content;    
            }, error =>
            {
            // se resuelve error 403 y 500
            this.helperService.httpGlobalError(error);

            if(error.status == 400) {
                this.helperService.showSaveCreditErrors(error.json().content, this.errors);
                this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
            }
            }
        );
    }

    public updatedFechaContrato(nuevaFechaContrato){
        //Si se modifico la fecha de inicio del crédito, se debe recargar la tabla de pagos 
        //para calcularla con base en esta nueva fecha
        this.tablaPagos.reloadTablaPagos();
    }
}


// WEBPACK FOOTER //
// ./src/app/creditos/nomina/detalles/nomina-detalles.component.ts